export const BASE_NAME = '@@FCC-ADMIN/GLOBAL/COMMON';

export const PERMISSION_REQUEST = `${BASE_NAME}/PERMISSION/REQUEST`;
export const PERMISSION_SUCCESS = `${BASE_NAME}/PERMISSION/SUCCESS`;
export const PERMISSION_FAILURE = `${BASE_NAME}/PERMISSION/FAILURE`;
export const PERMISSION_RESET = `${BASE_NAME}/PERMISSION/RESET`;

export const USERLIST_REQUEST = `${BASE_NAME}/USERLIST/REQUEST`;
export const USERLIST_SUCCESS = `${BASE_NAME}/USERLIST/SUCCESS`;
export const USERLIST_FAILURE = `${BASE_NAME}/USERLIST/FAILURE`;

export const GENERATECODE_REQUEST = `${BASE_NAME}/GENERATECODE/REQUEST`;
export const GENERATECODE_SUCCESS = `${BASE_NAME}/GENERATECODE/SUCCESS`;
export const GENERATECODE_FAILURE = `${BASE_NAME}/GENERATECODE/FAILURE`;
export const GENERATECODE_RESET = `${BASE_NAME}/GENERATECODE/RESET`;

export const SENDINVITATION_REQUEST = `${BASE_NAME}/SENDINVITATION/REQUEST`;
export const SENDINVITATION_SUCCESS = `${BASE_NAME}/SENDINVITATION/SUCCESS`;
export const SENDINVITATION_FAILURE = `${BASE_NAME}/SENDINVITATION/FAILURE`;
export const SENDINVITATION_RESET = `${BASE_NAME}/SENDINVITATION/RESET`;

export const USER_REPORT_INFO_REQUEST = `${BASE_NAME}/USERREPORT/REQUEST`;
export const USER_REPORT_INFO_SUCCESS = `${BASE_NAME}/USERREPORT/SUCCESS`;
export const USER_REPORT_INFO_FAILURE = `${BASE_NAME}/USERREPORT/FAILURE`;
export const USER_REPORT_INFO_RESET = `${BASE_NAME}/USERREPORT/RESET`;

export const USERDETAIL_INITIAL = 'USERDETAIL_INITIAL';
export const USERDETAIL_CLEAR_RESENDSERID = 'USERDETAIL_CLEAR_RESENDSERID';

export const BLANK = `${BASE_NAME}/BLANK`;

export const CLEAR_GENECODE = 'CLEAR_GENECODE';
export const CLEAR_RESENDSERID = 'CLEAR_RESENDSERID';

export const DOWNLOAD_FILE_TRUE = `DOWNLOAD_FILE_TRUE`;
export const DOWNLOAD_FILE_FALSE = `DOWNLOAD_FILE_FALSE`;
export const DOWNLOAD_FILE_SUCCESS = 'DOWNLOAD_FILE_SUCCESS';
export const DOWNLOAD_FILE_FAILED = 'DOWNLOAD_FILE_FAILED';
export const SHOW_DOWNLOAD_FILE_NOTI_TRUE = 'SHOW_DOWNLOAD_FILE_NOTI_TRUE';
export const SHOW_DOWNLOAD_FILE_NOTI_FALSE = 'SHOW_DOWNLOAD_FILE_NOTI_FALSE';

export const CANCELINVITATION_REQUEST = `${BASE_NAME}/CANCELINVITATION/REQUEST`;
export const CANCELINVITATION_SUCCESS = `${BASE_NAME}/CANCELINVITATION/SUCCESS`;
export const CANCELINVITATION_FAILURE = `${BASE_NAME}/CANCELINVITATION/FAILURE`;
export const CANCELINVITATION_RESET = `${BASE_NAME}/CANCELINVITATION/RESET`;

export const CLEAR_CANCELINVITATION = 'CLEAR_CANCELINVITATION';

export const DELETE_INVESTOR_REQUEST = `${BASE_NAME}/DELETE/INVESTOR/REQUEST`;
export const DELETE_INVESTOR_SUCCESS = `${BASE_NAME}/DELETE/INVESTOR/SUCCESS`;
export const DELETE_INVESTOR_FAILURE = `${BASE_NAME}/DELETE/INVESTOR/FAILURE`;
export const DELETE_INVESTOR_RESET = `${BASE_NAME}/DELETE/INVESTOR/RESET`;
export const CLEAR_DELETE_INVESTOR = `CLEAR_DELETE_INVESTOR`;
export const USER_LIST_DELETE_NOTIFICATION = `USER_LIST_DELETE_NOTIFICATION`;

export const DELETE_INVESTOR_IN_HOME_PAGE = 'DELETE_INVESTOR_IN_HOME_PAGE';
export const DELETE_INVESTOR_IN_DETAIL_PAGE = 'DELETE_INVESTOR_IN_DETAIL_PAGE';
export const DELETE_INVESTOR_IN_USER_LIST = 'DELETE_INVESTOR_IN_USER_LIST';

export const USERLIST_CLEAR_SEARCH_DATA = 'USERLIST_CLEAR_SEARCH_DATA';
export const USERLIST_SAVE_SEARCH_DATA = 'USERLIST_SAVE_SEARCH_DATA';

export const INVITE_COUNTRY_CODE_FAILURE = `${BASE_NAME}/INVITE/COUNTRY/CODE/FAILURE`;
export const INVITE_COUNTRY_CODE_REQUEST = `${BASE_NAME}/INVITE/COUNTRY/CODE/REQUEST`;
export const INVITE_COUNTRY_CODE_SUCCESS = `${BASE_NAME}/INVITE/COUNTRY/CODE/SUCCESS`;
